import Vue from 'vue';
import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import tlp from './payBalance.vue';
import Datepicker from 'vuejs-datepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import PayMethod from '../../components/payMethod';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import { Validator } from 'vee-validate';
import { forEach, round, isString, isNumber } from 'lodash-es';
import PayPal from 'vue-paypal-checkout';
import { Loading } from 'element-ui';
import util from '../../shared/util';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import switchBillingToService from '../../shared/switchBillingToService';
import qs from 'qs';
Vue.use(Loading);
@Component({
    name: 'PayBalacne',
    mixins: [tlp],
    components: {
        Datepicker,
        UinsDefaultSelect,
        PayMethod,
        PayPal,
    },
})
export default class PayBalance extends Vue {
    creditMemosList: any = {};
    selectCreditMemo: any = {};
    totalPayCreditMemo: any = 0;
    isPayCreditMemo: boolean = false;
    creditMemoConfirm: boolean = false;

    showErrTip: boolean = false;
    errorText: String = '';
    payMethod: any = {};
    payOption: any = '';
    payOption2: any = '';
    list: any = [];
    billToId: string = '';
    totalBalance: any = 0;
    subTotal: any = 0;
    creditAmount: any = 0;
    totalBalanceByCredit: any = 0;
    paymentMethodType: any = '';
    prQuoteId: any = '';
    creditAvailable: any = 0;
    useCredit: Boolean = false;
    applyCM: Boolean = false;
    invoice_id_ary: any = [];
    isPay: Boolean = false;
    buttonStyle: any = {
        label: 'pay',
        size: 'small',
        shape: 'rect',
        color: 'gold',
    };
    credentials: any = {
        sandbox: '',
        production: '',
    };
    payLoading: Boolean = false;

    @Inject() $validator: Validator;

    @Prop({
        default: 'Pay outstanding balance',
    })
    title: string;

    @Prop({
        default: '',
    })
    quoteId: any;

    @Prop({
        default: '',
    })
    orderId: any;

    @Prop({
        default: false,
    })
    needCreditMemo: boolean;

    @Prop({
        default: '1',
    })
    payOptionVal: any;

    @Prop({
        default: function() {
            return [];
        },
    })
    payList: Array<any>;

    @Prop({
        default: function() {
            return [];
        },
    })
    outstandingList: Array<any>;

    @Prop({ default: true })
    showList: Boolean;

    env: String = '';
    selectPayMent: any = {};
    isNeedCreditMemo: boolean = false;

    @Watch('needCreditMemo')
    getNeedCreditMemo(value: any) {
        if (value) {
            this.getCreditMemosList();
        }
    }
    created() {
        this.getUserBillToId();
        this.getPayPalClientId();
    }

    async mounted() {
        this.setPayList();
        /*await util.onSameAsAddress({ orderId: this.orderId }).then((res: any) => {
      this.shipperAddress = res;
    });*/
    }

    paymentAuthorized(data: any) {
        console.log(data);
    }

    paymentCompleted(data: any) {
        this.afterPayPal(data);
    }

    paymentCancelled(data: any) {
        console.log(data);
    }

    private shipperAddress: any = {};

    getPayPalClientId() {
        tmsServiceBackend.get(`/paypal/client`).then(
            (res: any) => {
                this.env = res.data.data.env;
                if (this.env == 'sandbox') {
                    this.credentials.sandbox = res.data.data.client_id;
                } else {
                    this.credentials.production = res.data.data.client_id;
                }
            },
            (err: any) => {
                this.showErrorFun(err.response.data.message);
            }
        );
    }

    setPayList() {
        if (this.payOptionVal == 1) {
            this.payOption = 1;
            this.list = this.payList;
        } else {
            this.payOption = 2;
            this.list = this.outstandingList;
        }
        this.invoice_id_ary = [];
        forEach(this.list, (item, index) => {
            this.invoice_id_ary.push(item.tms_ar_id);
        });
        this.countAmount();
    }

    getUserBillToId() {
        let params: any = {
            UserID: localStorage.UserID,
            UserToken: localStorage.UserToken,
        };
        switchBillingToService.post().then(
            (res: any) => {
                if (res.data.billing) {
                    this.billToId = res.data.billing.location_id;
                    this.creditAvailable = res.data.billing.request_credit_limit
                        ? Number(res.data.billing.request_credit_limit)
                        : 0;
                    if (this.needCreditMemo) {
                        this.getCreditMemosList();
                    }
                }
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    @Watch('payOption')
    changeList() {
        this.useCredit = false;
        this.creditAmount = 0;
        if (this.payOption == 1) {
            this.list = this.payList;
        } else {
            this.list = this.outstandingList;
        }
        this.countAmount();
    }

    selectPayMethod(item: any) {
        this.selectPayMent = item;
        if (this.selectPayMent.account)
            this.selectPayMent.account = this.selectPayMent.account.replace(/\s+/g, '');
        this.paymentMethodType = item.payment_method;
        this.countAmount();
    }

    countAmount() {
        let totalBalance: any = 0;

        forEach(this.list, (item, index) => {
            totalBalance += Number(item.balance);
        });

        totalBalance =
            totalBalance - (this.totalPayCreditMemo ? Number(this.totalPayCreditMemo) : 0);

        this.subTotal = this.toFixedValue(totalBalance, 2);

        if (this.paymentMethodType == 'CC' || this.paymentMethodType == 'Paypal') {
            totalBalance = this.toFixedValue((totalBalance * 105) / 100, 2);
        }

        this.totalBalanceByCredit = this.toFixedValue(totalBalance - this.creditAmount, 2);

        this.totalBalance = this.toFixedValue(totalBalance, 2);
    }

    chooseCreditAvailable() {
        if (this.useCredit) {
            if (this.totalBalanceByCredit > this.creditAvailable) {
                this.totalBalanceByCredit = this.toFixedValue(
                    this.totalBalanceByCredit - this.creditAvailable,
                    2
                );
                this.creditAmount = this.creditAvailable;
            } else {
                this.creditAmount = this.totalBalanceByCredit;
                this.totalBalanceByCredit = 0;
            }
        } else {
            this.creditAmount = 0;
            this.totalBalanceByCredit = this.totalBalance;
        }
    }

    async charge() {
        this.isPay = true;
        this.payLoading = true;
        if (this.payMethod.payment_method == 'Paypal') {
            this.chargePaypal();
        } else {
            let result = await this.$validator.validateAll();
            if (!result) {
                this.showErrorFun('Please choose payment method.');
                return;
            }
            let param = this.setChargeParam();

            if (this.isPayCreditMemo) {
                param['creditMemo'] = this.getApplyCreditMemoForm();
            }
            tmsServiceBackend.post(`tms/invoice/apply/charge`, qs.stringify(param)).then(
                (res: any) => {
                    this.$emit('chargeSuccess', true);
                    this.payLoading = false;
                },
                (err: any) => {
                    this.isPay = false;
                    this.payLoading = false;
                    this.showErrorFun(err.response.data.message);
                }
            );
        }
    }
    getCreditMemosList() {
        let params: any = {
            billto_id: this.billToId,
            company_id: localStorage.company_id,
        };

        tmsServiceBackend.get(`/cpv2/creditmemo/list?${qs.stringify(params)}`).then(
            (res: any) => {
                let data: any = res.data.data;
                for (let index in data) {
                    data[index]['credit_memos_last_four'] = data[index]['invoiceNumber'].substring(
                        data[index]['invoiceNumber'].length - 4
                    );
                }
                this.creditMemosList = data;
            },
            (err: any) => {
                this.showErrorFun(err.data.message);
            }
        );
    }

    setSelectCreditMemo(item: any) {
        this.selectCreditMemo = item;
    }

    showCreditMemoConfirm() {
        if (!this.selectCreditMemo) {
            this.showErrorFun('Please select the credit memos you wish to apply');
            return;
        }
        let creditMemo: any = this.selectCreditMemo;
        let involice_amount_list: any = [];
        let payAmount: any =
            this.subTotal >= creditMemo.balance ? creditMemo.balance : this.subTotal;
        forEach(this.list, (item, index) => {
            let itemPayAmount: any = payAmount >= item.balance ? item.balance : payAmount;
            if (itemPayAmount > 0) {
                involice_amount_list.push({
                    Amount: itemPayAmount,
                    InvoiceNumber: item.invoice_no,
                    InvoiceId: 0,
                });

                itemPayAmount = payAmount - itemPayAmount;
            }
        });
        this.totalPayCreditMemo =
            this.subTotal >= creditMemo.balance ? creditMemo.balance : this.subTotal;
        this.creditMemoConfirm = true;
    }

    closePlayCrediMemoConfirm() {
        this.creditMemoConfirm = false;
    }
    lockCreditMemo() {
        this.isPayCreditMemo = true;
        this.countAmount();
        this.closePlayCrediMemoConfirm();
    }
    getApplyCreditMemoForm() {
        let creditMemo: any = this.selectCreditMemo;
        let involice_amount_list: any = [];
        let payAmount: any = this.totalPayCreditMemo;
        forEach(this.list, (item, index) => {
            let itemPayAmount: any = payAmount >= item.balance ? item.balance : payAmount;
            if (itemPayAmount > 0) {
                involice_amount_list.push({
                    Amount: itemPayAmount,
                    InvoiceNumber: item.invoice_no,
                    InvoiceId: 0,
                });

                itemPayAmount = payAmount - itemPayAmount;
            }
        });

        let params: any = {
            billto_id: this.billToId,
            balance: creditMemo.balance,
            apply_amount: this.totalPayCreditMemo,
            current_memo_id: creditMemo.invoiceID,
            involice_amount_list: involice_amount_list,
            company_id: localStorage.company_id,
        };

        return params;
    }
    applyCreditMemo() {
        this.payLoading = true;
        tmsServiceBackend.post(`/cpv2/creditmemo/apply`, this.getApplyCreditMemoForm()).then(
            (res: any) => {
                this.payLoading = false;
                if (res.data.status == 1) {
                    this.isPayCreditMemo = true;
                    this.totalBalanceByCredit = this.toFixedValue(
                        this.totalBalanceByCredit - this.totalPayCreditMemo,
                        2
                    );
                    this.closePlayCrediMemoConfirm();

                    this.countAmount();
                    if (this.totalBalanceByCredit == 0) {
                        this.$emit('chargeSuccess', true);
                    }
                } else {
                    this.showErrorFun(res.data.message);
                }
            },
            (err: any) => {
                this.isPay = false;
                this.payLoading = false;
                this.showErrorFun(err.response.data.message);
            }
        );
    }

    chargePaypal() {
        let params: any = {
            invoice_id_ary: this.invoice_id_ary,
            billto_id: this.billToId,
            paypal_email: this.payMethod.text_1,
            pay_method_id: this.payMethod.location_cx1_id,
            paymethod_id: this.payMethod.location_cx1_id,
            apply_amount: this.totalBalanceByCredit,
            unis_credit_amount: this.creditAmount,
            call_from: 'CP',
            additional_quote_lines: [],
        };
        tmsServiceBackend.post(`/paypal/invoice/create`, params).then(
            (res: any) => {
                window.open('https://www.paypal.com/us/home');
                this.$emit('chargeSuccess', true);
            },
            (err: any) => {
                this.isPay = false;
                this.showErrorFun(err.response.data.message);
            }
        );
    }

    afterPayPal(data: any) {
        let params: any = {
            invoice_id_ary: this.invoice_id_ary,
            billto_id: this.billToId,
            apply_amount: this.totalBalanceByCredit,
            call_from: 'CP',
            pay_id: data.id,
            paypal_account: data.payer.payer_info.email,
            additional_quote_lines: [],
            billing_city: data.payer.payer_info.shipping_address.city,
            billing_state: data.payer.payer_info.shipping_address.state,
            billing_zip: data.payer.payer_info.shipping_address.postal_code,
            billing_street: data.payer.payer_info.shipping_address.line1,
            billing_country: data.payer.payer_info.shipping_address.country_code,
        };
        forEach(this.list, (item, index) => {
            let param: any = {};
            param.ar_id = item.tms_ar_id;
            param.lane_text = 'Transaction fee 5%.';
            param.calc_text = 'Transaction fee 5%.';
            param.type = 'CHARGE-OTHER';
            param.amount = this.toFixedValue(this.subTotal * 0.05, 2);
            params.additional_quote_lines.push(param);
        });

        if (this.isPayCreditMemo) {
            params['creditMemo'] = this.getApplyCreditMemoForm();
        }
        tmsServiceBackend.post(`/paypal/after/pay`, params).then(
            (res: any) => {
                this.$emit('chargeSuccess', true);
                this.payLoading = false;
            },
            (err: any) => {
                this.isPay = false;
                this.payLoading = false;
                this.showErrorFun(err.response.data.message);
            }
        );
    }

    setChargeParam() {
        let param: any = {
            invoice_id_ary: [],
            billto_id: this.billToId,
            unis_credit_amount: this.creditAmount,
            pay_method_id: this.selectPayMent.paymethod_id,
            paymethod_id: this.selectPayMent.paymethod_id,
            additional_quote_lines: [],
            call_from: 'CP',
            billing_city: this.selectPayMent.location_city,
            billing_state: this.selectPayMent.location_state,
            billing_zip: this.selectPayMent.zip,
            billing_street: this.selectPayMent.location_street,
            billing_street2: this.selectPayMent.location_street2,
            billing_country: 'US',
            account: this.selectPayMent.account,
            exp_date: this.selectPayMent.exp_date,
            name_on_card: this.selectPayMent.name_on_card,
            zip: this.selectPayMent.zip,
            cv: this.selectPayMent.cv,
            apply_amount: this.totalBalanceByCredit,
        };
        forEach(this.list, (item, index) => {
            param.invoice_id_ary.push(item.tms_ar_id);
        });
        forEach(this.list, (item, index) => {
            let params: any = {};
            params.ar_id = item.tms_ar_id;
            if (this.paymentMethodType == 'CC' || this.paymentMethodType == 'Paypal') {
                params.lane_text = 'Transaction fee 5%.';
                params.calc_text = 'Transaction fee 5%.';
                params.type = 'CHARGE-OTHER';
                params.amount = this.toFixedValue(this.subTotal * 0.05, 2);
                param.additional_quote_lines.push(params);
            } else {
                params.amount = 0;
            }
        });
        return param;
    }

    toFixedValue(oldNumber: Number | String, setNum: Number | String) {
        let resultValue = oldNumber;
        if (isNumber(oldNumber)) {
            if (isNumber(setNum)) {
                resultValue = round(oldNumber, setNum);
            } else {
                resultValue = round(oldNumber, Number(setNum));
            }
        } else if (isString(oldNumber)) {
            if (isNumber(setNum)) {
                resultValue = round(Number(oldNumber), setNum);
            } else {
                resultValue = round(Number(oldNumber), Number(setNum));
            }
        }
        return resultValue;
    }

    closeModal() {
        this.$emit('closePay', true);
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/payBalance/index.ts